import * as constants from '../constants';

// AutoComplete Action Creators
export function updateUserSearchResults(userSearchResults) {
  return {
    type: constants.UPDATE_USER_SEARCH_RESULTS,
    userSearchResults,
  };
}

export function updateUserSearchResultsHeight(height) {
  return {
    type: constants.UPDATE_USER_SEARCH_RESULTS_HEIGHT,
    height,
  };
}

export function changeUserSearchStatus(status) {
  return {
    type: constants.CHANGE_USER_SEARCH_STATUS,
    status,
  };
}

export function changeUserSearchInView(status) {
  return {
    type: constants.CHANGE_USER_SEARCH_IN_VIEW,
    status,
  };
}

export function addAutoCompleteSelectedUser(user) {
  return {
    type: constants.ADD_AUTO_COMPLETE_SELECTED_USER,
    user,
  };
}

export function removeSelectedUserClick(index) {
  return {
    type: constants.REMOVE_SELECTED_USER,
    index,
  };
}

export function removeAllSelectedUsers() {
  return {
    type: constants.REMOVE_ALL_SELECTED_USERS,
  };
}

export function changeHoverSelectedUser(index) {
  return {
    type: constants.CHANGE_SELECTED_USER,
    index,
  };
}

export function updateAutoCompleteTextAreaValue(value) {
  return {
    type: constants.UPDATE_AUTO_COMPLETE_TEXT_AREA_VALUE,
    value,
  };
}

// Comments Action Creators
export function updateCommentUserInfo(comment) {
  return {
    type: constants.UPDATE_COMMENT_INFO,
    comment,
  };
}

export function togglePreview(toggle) {
  return {
    type: constants.TOGGLE_PREVIEW,
    toggle,
  };
}

export function addTempUserComment(comment) {
  return {
    type: constants.ADD_USER_COMMENT,
    comment,
  };
}

export function addTempCommentUtmSource(utmSource) {
  return {
    type: constants.ADD_COMMENT_UTM_SOURCE,
    utmSource,
  };
}

export function addTempUserName(name) {
  return {
    type: constants.ADD_USER_NAME,
    name,
  };
}

export function addUserEmail(email) {
  return {
    type: constants.ADD_USER_EMAIL,
    email,
  };
}

export function toggleImageLoading(imageNumber) {
  return {
    type: constants.TOGGLE_IMAGE_LOADING,
    imageNumber,
  };
}

export function addUploadedPhoto(uploadedImageObject, index) {
  return {
    type: constants.ADD_UPLOADED_PHOTO,
    uploadedImageObject,
    index,
  };
}

export function deleteUploadedPhoto(index) {
  return {
    type: constants.DELETE_UPLOADED_PHOTO,
    index,
  };
}

export function allDoneClick(toggle) {
  return {
    type: constants.TOGGLE_DISPLAY_FINAL_MESSAGE,
    toggle,
  };
}

export function videoUploadSuccessful(toggle) {
  return {
    type: constants.TOGGLE_VIDEO_UPLOAD_SUCCESS,
    toggle,
  };
}

export function addVideoFileName(fileName) {
  return {
    type: constants.ADD_VIDEO_FILE_NAME,
    fileName,
  };
}

export function addVideoUploadConfig(videoUpload) {
  return {
    type: constants.ADD_VIDEO_UPLOAD_CONFIG,
    videoUpload,
  };
}

export function toggleCommentsInfoReceived(toggle) {
  return {
    type: constants.TOGGLE_COMMENTS_INFO_RECEIVED,
    toggle,
  };
}

// Cropper Action Creators
export function updateScaleFactor(scaleFactor) {
  return {
    type: constants.UPDATE_SCALE_FACTOR,
    scaleFactor,
  };
}

// Invites Action Creators
export function updateInviteUserInfo(invites) {
  return {
    type: constants.UPDATE_USER_INFO,
    invites,
  };
}

export function sentEmailAddresses(emailList) {
  return {
    type: constants.ADD_EMAILS_SENT,
    emailList,
  };
}

export function changeAlertStatus(changeValue) {
  return {
    type: constants.CHANGE_ALERT_STATUS,
    changeValue,
  };
}

export function updateInputAreaHeight(height) {
  return {
    type: constants.UPDATE_INPUT_AREA_HEIGHT,
    height,
  };
}

export function addDuplicateInfo(resendUrl, emails) {
  return {
    type: constants.ADD_DUPLICATE_INFO,
    resendUrl,
    emails,
  };
}

export function addRestrictedEmails(emails) {
  return {
    type: constants.ADD_RESTRICTED_EMAILS,
    emails,
  };
}

export function toggleDelayDisplayAlert(status) {
  return {
    type: constants.TOGGLE_DELAY_DISPLAY_ALERT,
    status,
  };
}

export function toggleInvitesInfoReceived(toggle) {
  return {
    type: constants.TOGGLE_INVITES_INFO_RECEIVED,
    toggle,
  };
}

// Translations Action Creators
export function updateTranslations(translationsData) {
  return {
    type: constants.UPDATE_TRANSLATIONS,
    translationsData,
  };
}

export function updatePrivacyPolicyLink(link) {
  return {
    type: constants.UPDATE_PRIVACY_POLICY_LINK,
    link,
  };
}

export function changeLocale(locale) {
  return {
    type: constants.UPDATE_LANGUAGE_LOCALE,
    locale,
  };
}

// Shared Action Creators
export function throwError(error) {
  return {
    type: constants.THROW_ERROR,
    error,
  };
}

export function throwBannedWordError(bannedWord) {
  return {
    type: constants.THROW_BANNED_WORD_ERROR,
    bannedWord,
  };
}

export function displayModal(name) {
  return {
    type: constants.MODAL_DISPLAY,
    name,
  };
}

export function displaySpinner(status) {
  return {
    type: constants.TOGGLE_SPINNER,
    status,
  };
}
